import { memberDisplayName, type OrgMember } from '@noconflict/contracts';
import { useTranslation } from 'react-i18next';
import { useRemoveMember } from '../../../entities/member';
import { identityErrorMessage } from '../../../shared/api/identity-error';
import { ConfirmDialog } from '../../../shared/ui/confirm-dialog';
import { toast } from '../../../shared/ui/sonner';

/** `members.manage`. Their workspace grants go with the membership (Q56). */
export function RemoveMemberDialog({
  org,
  member,
  onOpenChange,
}: {
  org: { id: string; name: string };
  /** The member to remove; null keeps the dialog closed. */
  member: OrgMember | null;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation('member');
  const remove = useRemoveMember(org.id);
  const name = member ? memberDisplayName(member) : '';
  return (
    <ConfirmDialog
      open={member !== null}
      onOpenChange={onOpenChange}
      title={t('remove.title', { name })}
      description={t('remove.body', { name, org: org.name })}
      confirmLabel={t('remove.confirm')}
      cancelLabel={t('remove.cancel')}
      errorMessage={identityErrorMessage}
      onConfirm={async () => {
        if (!member) return;
        await remove.mutateAsync(member.user_id);
        toast.success(t('remove.done'));
      }}
    />
  );
}
